<template>
    <div> 
        <div class="row">
            <div class="col-md-12 grafico-line"  style="margin-top: -40px; z-index: 1;">
                <graficobarraagrupada v-bind:agrupamento = "vagrupamento" v-bind:series = "vseries">
                </graficobarraagrupada>
            </div>
        </div>
    </div>
</template>

<script>
import util from '../../utilitarios/util';
import Graficobarraagrupada from '../../components/cmpgraficobarraagrupada.vue'
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "demvendedores",

  components:{
    'graficobarraagrupada' : Graficobarraagrupada,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        isloading               : false,  
        usuariologado           : this.$store.state.usuario,
        //variáveis 
        vseries                 : [],
        vagrupamento            : [],

        filiaisusuario          : '',
    }
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
  ],
  methods:{
        defselect2(){
            let vself = this;   
           
            let sqliniconta = 'select * from tbcontasfluxocaixa ';
            let sqlfimconta = vself.filiaisusuario !== '' ? 'where upper(descricao) like upper("%@@%") and idfilial in ('+vself.filiaisusuario+')' : 'where upper(descricao) like upper("%@@%")';                                                               
        },
        mtdformatavalordecimal(valor){
		    return util.formatarvalor(valor, '');
        },
        mtdexecutadash(){
            let vself  = this;
            //vself.isloading = true;
            vself.$emit('handlerLoader', true);
            if (vself.lstfiliais.length === 0 && parseInt(vself.utodasfiliais) === 0){
                vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
                return;
            }                
            vself.pdetalhartodos = false;
            let filtro          = ' and mf.dtlancamento between "'+util.InverterData(vself.pdtini)+'" and "'+util.InverterData(vself.pdtfim)+'"';            
            if (vself.lstfiliais.length > 0){
                let stringfilial = vself.lstfiliais.join(',');
                filtro = filtro + ' and cf.idfilial in ('+stringfilial+')';
            }                               
            let parametros = [
                {parametro: 'op',           valor: 'graficodemonstrativo'},
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'filtro',       valor: filtro},
                {parametro: 'idfilial',     valor: JSON.stringify(vself.lstfiliais)},
            
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
            retorno.then(function (response) {
                let agrupamento =  response.data.agrupamento;
                vself.vagrupamento = []
                agrupamento.forEach(item => {
                    vself.vagrupamento.push(item.name);
                });
                vself.vseries = response.data.series
                vself.$emit('handlerLoader', false);
                //vself.isloading = false;
            }).catch(function (response) {
                //vself.isloading = false;
                vself.$emit('handlerLoader', false);
            });
        },
  },
  mounted(){
    setTimeout(() => {
        if (util.verificasessao(this)) {
            let vself = this;
            vself.$emit('handlerLoader', true);
            vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
            let parametros = [
                {parametro: 'op', valor: 'dadosusuario'},
                {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
            retorno.then(function (response) {
                vself.filiaisusuario = response.data.filiaisusuario;
                //vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                //vself.$emit('handlerLoader', false);
            });
        }  


        this.mtdexecutadash();
        this.defselect2(); 
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
       
   